import React from 'react'
import{BsGithub,BsInstagram,BsLinkedin} from 'react-icons/bs'

function SocialMedia() {
  return (
    <div className='app__social'>
      <div>
      <a href='https://github.com/kodiyarasuc' target='_blank'><BsGithub/></a>
      </div>
      <div>
      <a href='https://www.linkedin.com/in/kodiyarasu-c-2057b8259/' target='_blank'><BsLinkedin/></a>
      </div>
      <div>
      <BsInstagram/>
      </div>
    </div>
  )
}

export default SocialMedia
